"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcppAuthorizedTransactionSerialization = void 0;
class OcppAuthorizedTransactionSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.authorized_utc = entity.authorized_utc
            ? entity.authorized_utc.getTime() * 1000000
            : undefined;
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.authorized_utc = entity.authorized_utc
            ? new Date(entity.authorized_utc / 1000000)
            : undefined;
        return copy;
    }
}
exports.OcppAuthorizedTransactionSerialization = OcppAuthorizedTransactionSerialization;
